<template>
  <div>
    <div v-if="showStatus" class="popContent">
      <div class="popTitle">{{ title }}</div>
      <div class="close" @click="closePop">关闭</div>
      <div>
        <div class="searchItem">
          查询条件：
          <el-input placeholder="请输入内容" v-model="input3" size="mini"></el-input>
          查询条件：
          <el-input placeholder="请输入内容" v-model="input3" size="mini"></el-input>
          <el-button size="mini" class="searchBtn">查询</el-button>
        </div>
      </div>
      <div>
        <el-table
            :data="tableData"
            size="mini"
            height="34vh"
            header-row-class-name="tableTH"
            :row-class-name="tableRowClassName"
            width="100%"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
        >
          <template v-for="(item, index) in tableLabel">
            <el-table-column :prop="item.prop" :label="item.label" :key="index" v-if="item.width"
                             :width="item.width"></el-table-column>
            <el-table-column :prop="item.prop" :label="item.label" :key="index" v-else></el-table-column>
          </template>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "popCompoment",
  props: ['showStatus', 'title', 'tableData', 'tableLabel', 'loading'],
  data() {
    return {
      input3: '',
      copyShowStatus: ''
    }
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 2 === 0) {
        return 'rowOne';
      }
      return '';
    },
    closePop(){
      console.log(666)
      this.$emit('closeHandle',false)
    }
  },
  watch:{
    showStatus(){
      this.copyShowStatus = this.showStatus;
    }
  }
}
</script>

<style scoped>
/deep/ .el-input {
  width: 130px;
}

.popContent {
  /*0A82D7*/
  background: #0D1456;
  width: 45vw;
  height: 50vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  padding: 20px;
  box-sizing: border-box;
  box-shadow: 0px 0px 3px 3px #0A82D7;

}
.searchItem{
  color: #fff;
  margin-bottom: 15px;
  margin-top: 15px;
}
.close{
  position: absolute;
  top: 20px;
  right: 20px;
  color: #fff;
}

.popTitle {
  color: #fff;
  font-size: 20px;
  letter-spacing: 2px;
  position: relative;
}

/deep/ .el-table td, /deep/ .el-table th.is-leaf {
  background: #030E43;
  /*060C30*/
  color: #fff;
  border: 0;
}

.tableTH {

}

/deep/ .el-table .rowOne td {
  background: #060C30;
}

/deep/ .el-table .rowTwo td {
  background: #060B4B;
}

/deep/ .el-table, .el-table__expanded-cell {
  background-color: transparent;
}

/deep/ .el-table {
  border: 1px solid #13358C;
}

/deep/ .el-table th.is-leaf,/deep/ .el-table td.gutter, /deep/ .el-table th.gutter {
  background: #18227C;
}

/deep/ .el-table .rowOne td {
  background: #0D1456;
}

/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
  background: #dddd;
}
/deep/ .el-table::before{
  height: 0;
}
.searchBtn{
  margin-left: 10px;
}
</style>